module.exports = __webpack_public_path__ + "static/media/gentoo.d5837fb6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/gentoo.png
// module id = 100
// module chunks = 0